import React from 'react';
import { Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '@lib/components/ErrorBoundary/ErrorBoundary';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import Typography from '@lib/components/Typography/Typography';
import Trans from '@lib/components/Trans/Trans';
import styles from './AccountLockedLayout.module.scss';

interface Props {
  loginUrl: string;
}

function AccountLockedLayout(props: Props): React.ReactElement {
  const { loginUrl } = props;
  const { t } = useTranslation();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <div className={styles.header}>
          <Button
            buttonText={t('back-to-log-in')}
            buttonType={ButtonTypes.quaternaryOutlined}
            to={loginUrl}
            leftIcon="arrow_back"
          />
          <Typography variant="h1">{t('account-locked-title')}</Typography>
          <Typography variant="body">
            <Trans i18nKey="account-locked-description" values={{ email }} />
          </Typography>
        </div>
        <div className={styles.body}>
          <ErrorBoundary location={location}>
            <Outlet />
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
}

export default AccountLockedLayout;
